export default "__VITE_ASSET__acfe4457__"